import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { FormatDatePipe } from '@df/ui/display/format-date.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'lp-product-in-stock-date',
    templateUrl: 'lp-product-in-stock-date.html',
    standalone: true,
    imports: [TranslationModule, FormatDatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpProductInStockDateComponent {
    @Input({
        required: true
    })
    product!: Product<IProductDataV2>;
}
